export const defaultColumns = [
  {label: 'Nome', value: 'display_name'}, 
  {label: 'Tipo de documento', value: 'kind', className: 'w-9'},
  {label: 'Ult. Atualização', value: 'updated_at', className: 'w-9'},
  {label: 'Validade', value: 'expiration_date', className: 'w-9'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]